import { keyframes } from 'styled-components';
import tw, { css, styled } from 'twin.macro';

import { Props } from './Skeleton';

const shimmerAnimation = keyframes`
	0% {
		background-position: 200% 0;
	}
	100% {
		background-position: -200% 0;
	}
`;

export const shimmer = css`
	${tw`bg-gradient-to-r from-gray-300 via-gray-100 to-gray-300 animate-pulse`}

	background-size: 400% 100%;
	animation: ${shimmerAnimation} 8s ease-in-out infinite;
`;

type StyledProps = Pick<Props, 'height' | 'width' | 'isLoading'>;

export const StyledSkeleton = styled.span<StyledProps>`
	${tw`rounded block relative`}

	height: ${({ height }) => height};
	width: ${({ width }) => width};

	${({ isLoading }) => isLoading && shimmer}
`;

export const StyledSkeletonContent = styled.span<{ isLoading: boolean }>`
	${({ isLoading }) => (isLoading ? tw`opacity-0` : tw`opacity-100`)}
`;
